module.exports = __webpack_public_path__ + "static/media/slider-7.a6d408cc.jpg";